import { render, staticRenderFns } from "./standings.vue?vue&type=template&id=60ce9efd&scoped=true&"
import script from "./standings.vue?vue&type=script&lang=js&"
export * from "./standings.vue?vue&type=script&lang=js&"
import style0 from "./standings.vue?vue&type=style&index=0&id=60ce9efd&prod&scoped=true&lang=scss&"
import style1 from "./standings.vue?vue&type=style&index=1&id=60ce9efd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce9efd",
  null
  
)

export default component.exports